import { render, staticRenderFns } from "./AddRootFolderCard.vue?vue&type=template&id=785ae4b9&scoped=true&"
import script from "./AddRootFolderCard.vue?vue&type=script&lang=js&"
export * from "./AddRootFolderCard.vue?vue&type=script&lang=js&"
import style0 from "./AddRootFolderCard.vue?vue&type=style&index=0&id=785ae4b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ae4b9",
  null
  
)

export default component.exports